<template>
  <div>
    <el-cascader
    :options="options"
    class="w100f"
    @change="handleChange"
    v-model="workarea" 
    :props="{checkStrictly: false}"
    >
  </el-cascader> 
  </div>
</template>

<script>
import areaJson from '../assets/js/china_address_v4.js';
export default {
  name: 'HelloWorld',
  props:['workareaList'],
  data () {
    return { 
      options: areaJson, //调用外部js文件的json数据
      workarea: this.workareaList, 
    }
  },
  methods: {
    handleChange(val){
        this.$emit('incre',val);
    },
  },
  watch: {
    workareaList(val) {
      this.workarea = val;
    },
  },
  mounted() {
        // console.log('111',this.workareaList);
    // this.getJsonData();
    // this.workarea = this.workareaList;
    },
  created() { 
    // console.log('111',this.workareaList);
    // this.getJsonData();
    // this.workarea = this.workareaList;
  }
}
</script>

<style lang="scss" scoped>
</style>